<template>
<div>
	<form @submit.prevent="validateBeforeSubmit">

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-3 col-form-label col-form-label-sm">*Servidor Envio:</label>
			<div class="col-sm-9">
				<select v-model="form.idServidorEnvio"
						name="idServidorEnvio"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('idServidorEnvio')}"
						class="form-control form-control-sm">
					<option value="null">ESCOLHA</option>
					<option v-for="(item, index) in _servidoresEnvio" v-show="item.ativo" :key="index" :value="item.id">{{item._descricao}}</option>
				</select>
				<span  class="invalid-feedback" v-show="errors.has('idServidorEnvio')">{{ errors.first('idServidorEnvio') }}</span>
			</div>
		</div>

		<hr />

		<div class="row">
			<div class="col-sm-12 text-right">
				<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
				<button class="btn btn-success btn-sm">
					<fa-icon icon="check" transform="left-3" /> SALVAR
				</button>
			</div>
		</div>
	</form>
</div>
</template>

<style>
.ir {
	position: absolute;
	right: 20px;
	top: 4px;
}
</style>


<script>
import _ from 'lodash'
import axios from '../../../../routers/axios';
export default {
	data() {
		return {
			servidoresEnvio: [],
			form: {
				idServidorEnvio: null,
				idConfigInspecao: 0,
			}
		};
	},

	computed: {

		_servidoresEnvio() {

			return _.orderBy(this.servidoresEnvio.map(item => {

				item._descricao = item.tipo.toUpperCase() + ' - ' + item.descricao

				return item
			}),['_descricao'], ['asc'])
		}
	},

	mounted() {},

	methods: {

		carregaDados(categoria, servidores) {
			//console.log("cp", atualizacao)

			this.servidoresEnvio = servidores;
			this.form.idConfigInspecao = categoria.id;
		},

		validateBeforeSubmit() {

			this.$validator.validateAll().then(result => {
				if (result) {
					this.salva();
				}
			});
		},

		salva() {
			var data = {
				idConfigInspecao: this.form.idConfigInspecao,
				idServidorEnvio: this.form.idServidorEnvio
			};

			this.$notify.loadIn('Salvando');

			axios.post(this._getUrl("api/manualmanutencaoenvio"), data).then(response => {
					// this.$emit("item-salvo", response.data);
					this.$notify.show('success', 'Manual enviado com sucesso!')
				}
			);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/views/followair/manutencao/cadastro/manual.vue